
import {
  RollPlus,
  AbilityScores
} from "@dndModels";

import CommonUtilities from "@utilities/common_utilities";
import { CommonUtilitiesClass } from "@utilities/common_utilities_class";
import { DAMAGE_TYPES } from "@dndModels/Constants";
import { AbilityScoreType, AttackType, DamageType, isDamageType } from "@dndModels/Types";


export class Attack {
  attack_rolls: RollPlus[];
  damage_rolls: RollPlus[];
  bonus_action: boolean;
  attack_type: AttackType;
  type: string;
  attack_string: string;
  damage_string: string;
  attack_stat: AbilityScoreType | "None" = "None";

  constructor(obj?: any) {
    this.bonus_action = obj ? obj.bonus_action : false;
    this.attack_type = "None";
    this.type = obj ? obj.type : "";
    this.attack_rolls = [];
    this.damage_rolls = []; 
    this.attack_string = "";
    this.damage_string = "";
    this.common_util = CommonUtilities.getInstance();
    this.recalc_attack_string(null);
    this.recalc_damage_string(null);
  }

  common_util: CommonUtilitiesClass;

  recalc_attack_string(ability_scores: AbilityScores | null) {
    this.attack_string = "";
    let bonuses = 0;
    for (const rolls of this.attack_rolls) {
      bonuses += rolls.flat;
      if (ability_scores && !["","None","undefined"].includes(rolls.ability_score)) {
        const mod = ability_scores.getModifier(rolls.ability_score);
        if (mod) {
          bonuses += mod;
        }
      }
      if (rolls.size === 1) {
        bonuses += rolls.count;
      } else if (rolls.size > 1 && rolls.count !== 0) {
        rolls.recalculate_string();
        this.attack_string += this.common_util.addPlusMaybe(rolls.as_string);
      }
    }
    this.attack_string = this.common_util.addPlusMaybe2Strings(this.attack_string, bonuses, true);
  }

  recalc_damage_string(ability_scores: AbilityScores | null, log_it = false) {
    this.damage_string = "";
    let bonuses = 0;
    for (const rolls of this.damage_rolls.filter(o => o.size === 1)) {
      bonuses += +rolls.count;
    }
    if (log_it) {
      debugger;
      console.log(this);
      console.log(bonuses);
      console.log(ability_scores);
    }
    this.damage_string = "";
    let type_less = true;
    let dt_string = "";
    for (const rolls of this.damage_rolls) {
      bonuses += +rolls.flat;
      if (ability_scores && !["","None","undefined"].includes(rolls.ability_score)) {
        const mod = ability_scores.getModifier(rolls.ability_score);
        if (mod) {
          bonuses += +mod;
        }
      }
      if ((rolls.size > 1 && rolls.count > 0) || this.damage_rolls.length === 1) {
        rolls.recalculate_string(false);
        if (log_it) {
          console.log(rolls);
          console.log(this.damage_string);
        }
        if (rolls.as_string !== "0d0") {
          this.damage_string = this.common_util.addPlusMaybe2Strings(this.damage_string, rolls.as_string);
        }
        // if (bonuses > 0) {
        //   this.damage_string = this.common_util.addPlusMaybe2Strings(this.damage_string, bonuses);
        // }
        if (!["","Typeless"].includes(rolls.type)) {
          dt_string += `{${rolls.type}}`;
          type_less = false;
        }
        // bonuses = 0;
      }
    }
    if (bonuses > 0) {
      this.damage_string = this.common_util.addPlusMaybe2Strings(this.damage_string, bonuses);
    }
    if (this.damage_rolls.length === 1 && this.damage_string === "") {
      this.damage_string = "0";
    }
    if (type_less) {
      const type_finder = this.damage_rolls.filter(o => !["","Typeless"].includes(o.type));
      if (type_finder.length > 0) {
        this.damage_string += `{${type_finder[0].type}}`;
      }
    } else {
      this.damage_string += dt_string;
    }
  }

  get main_damage_type() {
    const roll = this.damage_rolls.find(o => isDamageType(o.type) && o.type !== "Typeless");
    if (roll) {
      return roll.type as DamageType;
    }
    return "Typeless";
  }

  copy(copyMe: Attack) {
    this.attack_rolls = copyMe.attack_rolls.map(o => o.clone());
    this.damage_rolls = copyMe.damage_rolls.map(o => o.clone());
    this.bonus_action = copyMe.bonus_action;
    this.type = copyMe.type;
    this.attack_string = copyMe.attack_string;
    this.damage_string = copyMe.damage_string;
  }

  clone() {
    const clone = new Attack();
    clone.copy(this);
    return clone;
  }
}